import { render, staticRenderFns } from "./InviteTab.vue?vue&type=template&id=3b4360cc&scoped=true"
import script from "./InviteTab.vue?vue&type=script&lang=js"
export * from "./InviteTab.vue?vue&type=script&lang=js"
import style0 from "./InviteTab.vue?vue&type=style&index=0&id=3b4360cc&prod&lang=scss&scoped=true"
import style1 from "./InviteTab.vue?vue&type=style&index=1&id=3b4360cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4360cc",
  null
  
)

export default component.exports